import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from 'antd/es/tooltip';
import { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useNavigate } from '../../../../features/providers/location-provider';
import { BreadcrumbButton, BreadcrumbText } from './styles';
const useOverflow = (content) => {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const updateOverflow = useCallback(() => {
        const element = ref.current;
        setIsOverflowing(!!element && element.scrollWidth > element.clientWidth);
    }, []);
    useEffect(() => {
        updateOverflow();
        const element = ref.current;
        if (!element || typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', updateOverflow);
            return () => window.removeEventListener('resize', updateOverflow);
        }
        const observer = new ResizeObserver(updateOverflow);
        observer.observe(element);
        return () => observer.disconnect();
    }, [content, updateOverflow]);
    return { isOverflowing, ref };
};
const OverflowBreadcrumb = ({ children, onClick, variant, }) => {
    const { isOverflowing, ref } = useOverflow(children);
    const title = isOverflowing ? children : undefined;
    if (variant === 'button') {
        return (_jsx(Tooltip, { title: title, children: _jsx(BreadcrumbButton, { ref: ref, onClick: onClick, children: children }) }));
    }
    return (_jsx(Tooltip, { title: title, children: _jsx(BreadcrumbText, { ref: ref, children: children }) }));
};
const useBreadcrumbRender = () => {
    const navigate = useNavigate();
    return useMemo(() => (route, _params, routes, _paths) => {
        const last = routes.indexOf(route) === routes.length - 1;
        return last ? (_jsx(OverflowBreadcrumb, { variant: "text", children: route.breadcrumbName })) : route.onClick ? (_jsx(OverflowBreadcrumb, { variant: "button", onClick: route.onClick, children: route.breadcrumbName })) : (!!route.path && (_jsx(OverflowBreadcrumb, { variant: "button", onClick: () => {
                navigate(`${route.path}`);
            }, children: route.breadcrumbName })));
    }, [navigate]);
};
export default useBreadcrumbRender;
